import { YearMonth } from '@js-joda/core';
import { CreateSerializer } from './CreateSerializer';
/**
 * Serializer for YearMonth
 */
export const yearMonthSerializer = CreateSerializer(serializeYearMonth, deserializeYearMonth);
function serializeYearMonth(value) {
    return value.toJSON();
}
function deserializeYearMonth(value) {
    return YearMonth.parse(value);
}
